import type { PaigeClient } from '@paige/api-client';
import { tenantHeader, unwrap } from './http';
import type { LeadReceipt, LeadRequest } from './types';

/** "Ask for an Enterprise quote" (docs/intake-and-account.md, "Enterprise leads"): one post, signed in or not. */
export interface LeadsApi {
  /** Sends the enquiry; with a tenant the lead carries the company. */
  create(lead: LeadRequest, tenant?: string): Promise<LeadReceipt>;
}

export function leadsApi(client: PaigeClient): LeadsApi {
  return {
    async create(lead, tenant) {
      const params = tenant ? { params: { header: tenantHeader(tenant) } } : {};
      return unwrap(await client.POST('/leads', { ...params, body: lead })) as LeadReceipt;
    },
  };
}
